import React from "react";
import Landing from "./Landing";

export default function Root() {
  return <Landing />;
}

